import { CompanyRanges } from '@app/src/types/organizations'
import { SolutionType } from '@app/src/types/resourceExplorer'

export const SOURCING_LEARN_MORE_URL = 'https://www.worldfavor.com/sustainable-sourcing-promo'

const COMPANY_RANGE_RANK: Record<CompanyRanges, number> = {
  [CompanyRanges.MICRO]: 0,
  [CompanyRanges.SMALL]: 1,
  [CompanyRanges.MEDIUM]: 2,
  [CompanyRanges.LARGE]: 3,
  [CompanyRanges.GIANT]: 4,
}
const MINIMUM_ELIGIBLE_COMPANY_RANGE = CompanyRanges.SMALL
const EXCLUDED_SOLUTIONS = new Set(
  [SolutionType.Sourcing, SolutionType.Investing, SolutionType.EsgReporting].map(s => s.toLowerCase()),
)

interface SourcingUpsellProfile {
  assignedSolutions: string[]
  companySizeRange: CompanyRanges | undefined
  revenueRange: CompanyRanges | undefined
}

function isBelowMinimumCompanyRange(range: CompanyRanges | undefined): boolean {
  if (range == null) return false

  return COMPANY_RANGE_RANK[range] < COMPANY_RANGE_RANK[MINIMUM_ELIGIBLE_COMPANY_RANGE]
}

export function shouldShowSourcingUpsell({
  assignedSolutions,
  companySizeRange,
  revenueRange,
}: SourcingUpsellProfile): boolean {
  if (assignedSolutions.length === 0) return false
  if (assignedSolutions.some(solution => EXCLUDED_SOLUTIONS.has(solution.toLowerCase()))) return false

  return ![companySizeRange, revenueRange].some(isBelowMinimumCompanyRange)
}
